// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2EvsO","title":"Images45_title__1ioaS","images":"Images45_images__1Nkby"};